var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.779 0a6.23 6.23 0 0 0-6.221 6.221c0 1.49.522 2.856 1.4 3.927L0 15.106.894 16l4.958-4.957a6.173 6.173 0 0 0 3.927 1.4A6.23 6.23 0 0 0 16 6.22 6.23 6.23 0 0 0 9.779 0zm0 1.244a4.968 4.968 0 0 1 4.977 4.977 4.968 4.968 0 0 1-4.977 4.977 4.968 4.968 0 0 1-4.977-4.977 4.968 4.968 0 0 1 4.977-4.977z",
    fill: "#3063D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSearch);
export default __webpack_public_path__ + "static/media/filter-search.ea222b052d3adf0bd100cf9e96084fb5.svg";
export { ForwardRef as ReactComponent };